import { categories } from '@/mocks/categories';

export default function ShopCategories() {
  return (
    <section className="w-full py-16 md:py-24 bg-background-100">
      <div className="max-w-6xl mx-auto px-6 md:px-8 lg:px-12">
        <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-950 text-center">
          Shop All Categories
        </h2>
        <p className="mt-3 text-sm text-foreground-500 font-sans text-center">
          Browse the complete Mulebuy spreadsheet product directory
        </p>

        <div className="mt-10 grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
          {categories.map((cat, index) => (
            <a
              key={cat.name}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="group bg-white rounded-xl border border-background-200 overflow-hidden hover:border-accent-200 transition-all duration-300 cursor-pointer"
            >
              <div className="relative overflow-hidden" style={{ aspectRatio: '1/1' }}>
                <img
                  src={cat.image}
                  alt={cat.name}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                {index === 0 && (
                  <span className="absolute top-3 left-3 px-2 py-0.5 text-xs font-semibold bg-accent-500 text-white rounded-full whitespace-nowrap">
                    Hot
                  </span>
                )}
              </div>
              <div className="p-3 md:p-4 text-center">
                <h3 className="font-sans text-sm font-semibold text-foreground-950">{cat.name}</h3>
                <p className="mt-1 text-xs text-foreground-400">Browse Now &rarr;</p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}